"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _Title = _interopRequireDefault(require("../Title"));

require("./EllipsisOptionComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var EllipsisOptionComponent = function EllipsisOptionComponent(_ref) {
  var placement = _ref.placement,
      menus = _ref.menus,
      id = _ref.id,
      className = _ref.className,
      isMasterCatalog = _ref.isMasterCatalog,
      icon = _ref.icon,
      record = _ref.record,
      isTitle = _ref.isTitle;

  var menuList = /*#__PURE__*/_react["default"].createElement(_antd.Menu, {
    key: "".concat(id, " menu")
  }, menus === null || menus === void 0 ? void 0 : menus.map(function (menu) {
    return menu && /*#__PURE__*/_react["default"].createElement(_antd.Menu.Item, {
      disabled: (menu === null || menu === void 0 ? void 0 : menu.disabled) || false,
      onClick: record ? function () {
        return menu === null || menu === void 0 ? void 0 : menu.actionFunction(record);
      } : function () {
        return menu === null || menu === void 0 ? void 0 : menu.actionFunction();
      },
      key: "".concat(id, " ").concat(menu === null || menu === void 0 ? void 0 : menu.menuItem)
    }, isTitle && /*#__PURE__*/_react["default"].createElement(_Title["default"], {
      className: "title-text label-title"
    }, menu === null || menu === void 0 ? void 0 : menu.title), menu === null || menu === void 0 ? void 0 : menu.menuItem);
  }));

  return /*#__PURE__*/_react["default"].createElement(_antd.Dropdown.Button, {
    key: "".concat(id, " dropdown"),
    className: "elipses-btn  ".concat(className ? className : "", " ").concat(isMasterCatalog ? "master" : ""),
    overlay: menuList || "",
    placement: placement || "bottomRight",
    icon: icon,
    getPopupContainer: function getPopupContainer() {
      return document.getElementById("app-container");
    },
    overlayClassName: "elipses-dropdown"
  });
};

var _default = EllipsisOptionComponent;
exports["default"] = _default;